import React, { SVGProps } from 'react';

const CheckboxOff: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M15.5 0H2.5C1.11929 0 0 1.11929 0 2.5V15.5C0 16.8807 1.11929 18 2.5 18H15.5C16.8807 18 18 16.8807 18 15.5V2.5C18 1.11929 16.8807 0 15.5 0ZM1 2.5C1 1.67157 1.67157 1 2.5 1H15.5C16.3284 1 17 1.67157 17 2.5V15.5C17 16.3284 16.3284 17 15.5 17H2.5C1.67157 17 1 16.3284 1 15.5V2.5Z" fill="#333333"/>
  </svg>
);

export default CheckboxOff;





